module.exports = __webpack_public_path__ + "static/media/logo.adca41d3.png";